/** Тексты публичного профиля / магрегатора (отдельные поля с запасом на старые колонки). */
export function therapistPublicShort(profile) {
    const v = profile?.therapist_aggregator_short ?? profile?.short_description;
    return v && String(v).trim() !== 'null' ? String(v).trim() : '';
}

export function therapistPublicFull(profile) {
    const v = profile?.therapist_aggregator_full ?? profile?.description;
    return v && String(v).trim() !== 'null' ? String(v).trim() : '';
}
